import { formatDate } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { _HttpClient } from '@delon/theme';
import { environment } from '@env/environment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { finalize } from 'rxjs';
import { FormService } from 'src/app/core/util/form.service';

import { DuitnowComponent } from './components/duitnow/duitnow.component';
import { DuitnowProxyComponent } from './components/duitnow-proxy/duitnow-proxy.component';
import { LocalUobComponent } from './components/local-uob/local-uob.component';
import { UobTtComponent } from './components/tt/tt.component';
import { OnlinePaymentService } from './online-payment.service';

@Component({
  selector: 'app-online-pay-modal',
  templateUrl: './online-pay-modal.component.html',
  styleUrls: ['./online-pay-modal.component.less'],
  standalone: false
})
export class OnlinePayModalComponent implements OnInit {
  useCrossBorderPayment = window.location.host !== 'account.qne.cloud';

  modeOptions: any[] = [
    { value: 1, label: 'Transfer to local UOB Account' },
    { value: 5, label: 'DuitNow Pay to Account' },
    { value: 3, label: 'DuitNow Transfer' },
    { value: 4, label: 'Telegraphic Transfer' }
  ];
  selectedMode: any = {};
  data: any = {};
  isVisible = false;
  okLoading = false;
  @ViewChild(LocalUobComponent) localUobComponent!: LocalUobComponent;
  @ViewChild(DuitnowComponent) duitnowComponent!: DuitnowComponent;
  @ViewChild(DuitnowProxyComponent)
  duitnowProxyComponent!: DuitnowProxyComponent;
  @ViewChild(UobTtComponent) ttComponent!: UobTtComponent;

  constructor(
    private fs: FormService,
    private http: _HttpClient,
    private srv: OnlinePaymentService,
    private msg: NzMessageService,
    private cdr: ChangeDetectorRef
  ) {
    // Change the label of the modeOptions to 'Cross Border Payment' if useCrossBorderPayment is true
    if (this.useCrossBorderPayment) {
      this.modeOptions.find(x => x.value === 4).label = 'Cross Border Payment';
    }
  }

  handleCancel() {
    this.isVisible = false;
  }

  ngOnInit(): void {
    return;
  }

  show(data: {
    local: { currency: string; amount: number };
    foreign: { currency: string; amount: number };
    payeeName: string;
    payForCode: string;
    currencies: string[];
  }) {
    data.currencies = [data.local.currency];
    this.modeOptions[3].disabled = false;
    if (data.local.currency !== data.foreign.currency) {
      data.currencies.push(data.foreign.currency);
    } else {
      this.modeOptions[3].disabled = true;
    }
    this.data = data;
    this.data.transactionType = 1;
    this.data.isOwnAcc = true;
    this.data.isResident = true;

    this.selectedMode = this.modeOptions.find(
      x => x.value === this.data.transactionType
    );
    this.isVisible = true;
  }

  handleOk() {
    let form: any = null;
    if (this.data.transactionType === 1) {
      form = this.localUobComponent.form;
    } else if (this.data.transactionType === 3) {
      form = this.duitnowProxyComponent.form;
    } else if (this.data.transactionType === 4) {
      form = this.ttComponent.form;
    } else if (this.data.transactionType === 5) {
      form = this.duitnowComponent.form;
    }
    if (!form) return;
    const amount = form.value.amount;
    const valid = this.fs.validate(form).isValid;
    form.controls.amount.setValue(amount);
    if (!valid) return;
    Object.assign(this.data, form.value);
    const body: any = { ...this.data };
    body.transferDate = formatDate(body.transferDate, 'yyyy-MM-dd', 'en-US');

    // remove unnecessary fields
    delete body.local;
    delete body.foreign;
    delete body.currencies;
    if (body.payeeBankCountry) body.payeeCountry = body.payeeBankCountry;
    this.okLoading = true;

    this.srv
      .validatePayment(body)
      .then(() => {
        this.http
          .post(`/api/uob/CreatePaymentLink?_silent=true&_raw=true`, body)
          .pipe(
            finalize(() => {
              this.okLoading = false;
            })
          )
          .subscribe({
            next: res => {
              const link = res.data;
              if (link) {
                window.open(link, '_blank');
                this.isVisible = false;
              } else {
                this.msg.error('Failed to create payment link!');
              }
            }
          });
      })
      .catch(() => {
        this.okLoading = false;
        this.isVisible = false;
        this.cdr.detectChanges();
      });
  }

  changeMode() {
    this.selectedMode = this.modeOptions.find(
      x => x.value === this.data.transactionType
    );
    this.cdr.detectChanges();
  }
}
